import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../mockData';
import { Sparkles } from 'lucide-react';
import ImageModal from './ImageModal';

const PhotoGallery = () => {
  const { language } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);

  const content = {
    en: {
      title: "Our Cleaning Excellence",
      subtitle: "Professional results that speak for themselves",
      cta: "Ready for a Spotless Space?",
      feedbackButton: "Leave Us a Review"
    },
    gr: {
      title: "Η Αριστεία του Καθαρισμού μας",
      subtitle: "Επαγγελματικά αποτελέσματα που μιλούν από μόνα τους",
      cta: "Έτοιμοι για έναν Άψογο Χώρο;",
      feedbackButton: "Αφήστε μας μια Κριτική"
    }
  };

  const t = content[language];

  return (
    <section className="pad-2xl" style={{ background: 'var(--bg-section)' }}>
      <div className="container">
        <div className="text-center mb-12 animate-fadeInUp">
          <h2 className="heading-2 mb-4">{t.title}</h2>
          <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
            {t.subtitle}
          </p>
        </div>

        {/* Expanded gallery with real photos */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-12">
          {/* First large photo - spans 2 columns and 2 rows */}
          <div 
            className="col-span-2 row-span-2 relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[0])}
          >
            <img 
              src={images.gallery[0]}
              alt="Cleaning result 1"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div 
            className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[1])}
          >
            <img 
              src={images.gallery[1]}
              alt="Cleaning result 2"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              style={{ aspectRatio: '1/1' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div 
            className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[2])}
          >
            <img 
              src={images.gallery[2]}
              alt="Cleaning result 3"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              style={{ aspectRatio: '1/1' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div 
            className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[3])}
          >
            <img 
              src={images.gallery[3]}
              alt="Cleaning result 4"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              style={{ aspectRatio: '1/1' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div 
            className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[4])}
          >
            <img 
              src={images.gallery[4]}
              alt="Cleaning result 5"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              style={{ aspectRatio: '1/1' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div 
            className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[5])}
          >
            <img 
              src={images.gallery[5]}
              alt="Cleaning result 6"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              style={{ aspectRatio: '1/1' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div 
            className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[6])}
          >
            <img 
              src={images.gallery[6]}
              alt="Cleaning result 7"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              style={{ aspectRatio: '1/1' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div 
            className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[7])}
          >
            <img 
              src={images.gallery[7]}
              alt="Cleaning result 8"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              style={{ aspectRatio: '1/1' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>

          <div 
            className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
            onClick={() => setSelectedImage(images.gallery[8])}
          >
            <img 
              src={images.gallery[8]}
              alt="Cleaning result 9"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              style={{ aspectRatio: '1/1' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>
        </div>

        {/* CTAs */}
        <div className="text-center animate-fadeInUp flex flex-col sm:flex-row gap-4 justify-center items-center" style={{ animationDelay: '0.8s' }}>
          <button
            onClick={() => {
              const element = document.getElementById('booking');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-primary"
          >
            {t.cta}
          </button>
          <a
            href="https://www.facebook.com/profile.php?id=61584596424715&locale=bg_BG"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
          >
            {t.feedbackButton}
          </a>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <ImageModal 
          src={selectedImage} 
          alt="Cleaning result" 
          onClose={() => setSelectedImage(null)}
        />
      )}
    </section>
  );
};

export default PhotoGallery;
